!function () {
  'use strict'
  customElements.get('quantity-counter') || customElements.define('quantity-counter', class extends HTMLElement {
    constructor () {
      super()
    }

    connectedCallback () {
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.buttonClickEvent = this.onButtonClick.bind(this);
      this.onQuantityChangeEvent = this.onQuantityChange.bind(this);

      this.input.addEventListener('keydown', this.preventInvalidKeys);

      this.input.addEventListener('change', this.onQuantityChangeEvent);
      this.querySelectorAll('button').forEach(btn => btn.addEventListener('click', this.buttonClickEvent));
    }

    preventInvalidKeys(event) {
      const invalidKeys = ['e', 'E', '+', '-', ',', '.'];
      if (invalidKeys.includes(event.key)) {
        event.preventDefault();
      }
    }

    onButtonClick (event) {
      event.preventDefault();
      const prevValue = this.input.value;
      const button = event.target.nodeName === 'BUTTON' ? event.target : event.target.closest('button');

      if (button.name === 'increase') this.input.stepUp();
      if (button.name === 'decrease') this.input.stepDown();

      if (prevValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }
    }

    onQuantityChange () {
      if (this.input.name === 'updates[]') {
        this.updateCart();
      }
    }

    updateCart () {
      if (this.input.value !== '') {
        this.dispatchEvent(new CustomEvent('theme:cart:update', {
          bubbles: true,
          detail: {
            id: this.input.dataset.id,
            quantity: this.input.value
          }
        }));
      }
    }
  });
}()
